import i18next from 'i18next';
import useStyles from 'style/js-style/components/thirdparties/ecovadis/EcovadisStyle';
import clsx from 'clsx';
import EcovadisProgressBullet from './EcovadisProgressBullet';
import AdditionalMessageAlert from 'components/AdditionalMessageAlert';

const EcovadisProgressSteps = ({ 
  evData, 
  progressSteps, 
  additionalMessage,
  isActiveHandler = () => { }, 
  isDoneHandler = () => { },
}) => {
  const { classes } = useStyles();

  return (
    <>
      <div className={classes.progressBullets}>
        {progressSteps?.map((step, index) => (
          <>
            <EcovadisProgressBullet
              key={step}
              order={index + 1}
              isActive={isActiveHandler(step, evData)}
              isDone={isDoneHandler(step, evData)}
              label={i18next.t(`ecovadis.steps.${step}`)}
            />
            {index < progressSteps.length -1 && <div className={clsx(classes.progressLine, isDoneHandler(step, evData) ? 'line-done' : '')}></div>}
          </>
        ))}
      </div>
      <div className={classes.progressMessage}>
        <AdditionalMessageAlert
          icon="lightbulb"
          message={additionalMessage}
        />
      </div>
    </>
  );
};

export default EcovadisProgressSteps;
